var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
import { useFormikContext } from 'formik'
import React from 'react'
import styled from 'styled-components'
import { useDetectOutsideClick } from '../../../../../hooks'
import { useODEntityContext } from '../../../context/useODEntityContext'
import { DragAndDropComponent } from './DragAndDropComponent'
var Wrapper = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ['\n  background-color: transparent;\n  border: 1px dashed gray;\n  cursor: pointer;\n  position: relative;\n'],
      ['\n  background-color: transparent;\n  border: 1px dashed gray;\n  cursor: pointer;\n  position: relative;\n']
    ))
)
export function ODFileInput(props) {
  var formikContext = useFormikContext()
  var entityContext = useODEntityContext()
  var _a = React.useState(false),
    isUploadViewOpen = _a[0],
    setIsUploadViewOpen = _a[1]
  var _b = React.useState(''),
    blobUrl = _b[0],
    setBlobUrl = _b[1]
  var dndRef = React.useRef(null)
  useDetectOutsideClick(
    function () {
      return setIsUploadViewOpen(false)
    },
    dndRef,
    isUploadViewOpen
  )
  var width = props.width,
    height = props.height,
    name = props.name,
    _c = props.style,
    style =
      _c === void 0
        ? function () {
            return {}
          }
        : _c,
    render = props.render,
    _d = props.validate,
    validate =
      _d === void 0
        ? function () {
            return true
          }
        : _d,
    accept = props.accept,
    onChange = props.onChange
  var _e = formikContext || {},
    setFieldValue = _e.setFieldValue,
    _f = _e.values,
    values = _f === void 0 ? {} : _f
  // @ts-ignore
  var v = values
  var fieldRendered = render(v, blobUrl, { formikContext: formikContext, entityContext: entityContext })
  var handleChange = React.useCallback(
    function (file, bUrl, value) {
      var _a, _b
      if (
        !((_b = (_a = validate) === null || _a === void 0 ? void 0 : _a(file)),
        _b !== null && _b !== void 0 ? _b : true)
      ) {
        return
      }
      setBlobUrl(bUrl)
      if (onChange) {
        onChange(file, bUrl, value)
      }
      setFieldValue(name, file)
    },
    [name, setFieldValue]
  )
  return React.createElement(
    Wrapper,
    {
      style: __assign({ width: width, height: height, border: isUploadViewOpen ? '0' : undefined }, style(v)),
      ref: dndRef,
      onDragEnter: function () {
        return setIsUploadViewOpen(true)
      },
      onClick: function () {
        return setIsUploadViewOpen(true)
      },
    },
    React.createElement(DragAndDropComponent, {
      accept: accept,
      style: { width: width, height: height },
      isOpen: isUploadViewOpen,
      onChange: function (file, bUrl) {
        return handleChange(file, bUrl, v)
      },
      onClose: function () {
        return setIsUploadViewOpen(false)
      },
      onDragLeave: function () {
        return setIsUploadViewOpen(false)
      },
      toggle: function () {
        return setIsUploadViewOpen(function (value) {
          return !value
        })
      },
    }),
    fieldRendered
  )
}
var templateObject_1
//# sourceMappingURL=ODFileInput.js.map
